import React, { useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import Box from '@mui/material/Box'

const Quill = ({ value, onChange }) => {
  return (
    <Box
        display="flex"
        flexDirection="column"
        width="100%"
        flex={2}
        paddingBottom={6}
      >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        style={{
          height: '100%',
          flex: 1,
          width: '100%',
        }}
      />
    </Box>
  )
}

export default Quill
